<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <h1 class="display-1">Add Fabric</h1>
        <v-text-field label="Name" v-model="fabric.name"></v-text-field>
        <v-text-field label="TWC Name" v-model="fabric.twcName"></v-text-field>
        <v-text-field label="Price From" v-model="fabric.priceFrom"></v-text-field>
        <v-select v-if="groups" v-model="fabric.group" :items="groups" item-value="_id" label="Group">
          <template slot="selection" slot-scope="data">
            {{ data.item.type }} - {{ data.item.name }}
          </template>
          <template slot="item" slot-scope="data">
            {{ data.item.type }} - {{ data.item.name }}
          </template>
        </v-select>
        <v-select v-model="fabric.category" :items="categories" item-text="name" item-value="_id" label="Category"></v-select>
        <v-select v-model="fabric.categorySFoldCentre" :items="categorySFoldCentre" item-text="name" item-value="_id" label="Category S-Fold Centre"></v-select>
        <v-select v-model="fabric.categoryNonSFoldCentre" :items="categoryNonSFoldCentre" item-text="name" item-value="_id" label="Category Non-S-Fold Centre"></v-select>
        <v-select v-model="fabric.categorySFoldOneWay" :items="categorySFoldOneWay" item-text="name" item-value="_id" label="Category S-Fold One Way"></v-select>
        <v-select v-model="fabric.categoryNonSFoldOneway" :items="categoryNonSFoldOneway" item-text="name" item-value="_id" label="Category Non-S-Fold One Way"></v-select>
        <v-text-field label="Small Image" v-model="fabric.smallImage"></v-text-field>
        <v-text-field label="Large Image" v-model="fabric.largeImage"></v-text-field>
        <v-text-field label="Min Width" v-model="fabric.minWidth"></v-text-field>
        <v-text-field label="Min Drop" v-model="fabric.minDrop"></v-text-field>
        <v-text-field label="Max Width" v-model="fabric.maxWidth"></v-text-field>
        <v-text-field label="Max Drop" v-model="fabric.maxDrop"></v-text-field>
        <v-text-field label="Margin Percent Addon" v-model="fabric.marginPercentAddon"></v-text-field>
        <v-checkbox label="Status" v-bind:to="fabric.status"></v-checkbox>
        <v-text-field label="Also Known As" v-model="fabric.alsoKnownAs"></v-text-field>
        <v-text-field label="Description" v-model="fabric.description"></v-text-field>
        <v-text-field label="Properties" v-model="fabric.properties"></v-text-field>
        <v-btn large color="primary" @click="addFabric()">Add Fabric</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import FabricGroupService from '@/services/FabricGroupService.js'
import FabricCategoryService from '@/services/FabricCategoryService.js'
import FabricService from '@/services/FabricService.js'
export default {
  data () {
    return {
      fabric: {
        name: null,
        twcName: null,
        priceFrom: null,
        group: null,
        category: null,
        categorySFoldCentre: null,
        categoryNonSFoldCentre: null,
        categorySFoldOneWay: null,
        categoryNonSFoldOneway: null,
        smallImage: null,
        largeImage: null,
        minWidth: null,
        minDrop: null,
        maxWidth: null,
        maxDrop: null,
        marginPercentAddon: null,
        status: null,
        alsoKnownAs: null,
        description: null,
        properties: null,
        starRating: null
      },
      groups: null,
      categories: null
    }
  },
  mounted () {
    this.getGroups()
    this.getCategories()
  },
  methods: {
    async getGroups () {
      const response = await FabricGroupService.getFabricGroups()
      this.groups = response.data.fabricGroup
    },

    async getCategories () {
      const response = await FabricCategoryService.getFabricCategories()
      this.categories = response.data.fabricCategories
    },

    async addFabric () {
      const response = await FabricService.createFabric(this.fabric)
      console.log(response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/fabrics/NewFabric.vue